module.exports = "<div class=\"outer-container\">\n  <div class=\"heading\">\n    <h1 class=\"heading--no-margin\">Social Log In</h1>\n  </div>\n\n  <div class=\"contents\">\n    <p>\n      Please wait. You'll be redirected shortly.\n    </p>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /tmp/build_769bc651/src/app/become/become.component.html
// module id = ../../../../../src/app/become/become.component.html
// module chunks = main